import PropTypes from "prop-types";
import Modal from "../Modal";
import BranchList from "./BranchList/BranchList";
import classes from "./BranchSelectionModal.module.css";

const BranchSelectionModal = (props) => {
  const { isOpen, onClose, onChangeBranch, currentSelectedBranchId, footer } =
    props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header="وجهة التوصيل"
      footer={footer}
    >
      <div className={classes["branch-selection-modal"]}>
        <p className={classes["branch-selection-modal__select-branch-text"]}>
          الرجاء اختيار وجهة التوصيل
        </p>
        <BranchList
          onChangeBranch={onChangeBranch}
          selectedBranchId={currentSelectedBranchId}
        />
      </div>
    </Modal>
  );
};

export default BranchSelectionModal;

BranchSelectionModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onChangeBranch: PropTypes.func,
  currentSelectedBranchId: PropTypes.number,
  footer: PropTypes.node,
};
